/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReportFlowContainer_settings = {
    readonly dsa: {
        readonly enabled: boolean;
    };
    readonly " $fragmentRefs": FragmentRefs<"ReportCommentFormContainer_settings">;
    readonly " $refType": "ReportFlowContainer_settings";
};
export type ReportFlowContainer_settings$data = ReportFlowContainer_settings;
export type ReportFlowContainer_settings$key = {
    readonly " $data"?: ReportFlowContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ReportFlowContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportFlowContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "DSAConfiguration",
            "kind": "LinkedField",
            "name": "dsa",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReportCommentFormContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '63f2626c00e9a8067e646df5f33b4f17';
export default node;
